export const countryMapper = {
  deu: 'Germany',
  esp: 'Spain',
  fra: 'France'
}
